import { render, staticRenderFns } from "./ResourcesFaqs.vue?vue&type=template&id=288acab2&scoped=true"
import script from "./ResourcesFaqs.vue?vue&type=script&lang=js"
export * from "./ResourcesFaqs.vue?vue&type=script&lang=js"
import style0 from "./ResourcesFaqs.vue?vue&type=style&index=0&id=288acab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288acab2",
  null
  
)

export default component.exports